import React from 'react';
import QuestionPanel from './QuestionPanel';
import DemographicsPanel from './DemographicsPanel';

function AppHeader() {
    return (
        <div className="app-header">
            <DemographicsPanel />
            <QuestionPanel />
        </div>
    );
}

export default AppHeader;
